<script lang="ts">
  import type { Snippet } from "svelte";
  import { onDestroy } from "svelte";
  import { draggable } from "@neodrag/svelte";
  import { positionModal } from "./actions/positionnode";
  import Close from "./icons/Close.svelte";
  import { trapFocus } from "./util";

  // based on:
  // https://svelte.dev/examples/modal
  // TODO: always true?
  interface Props {
    title?: string;
    open?: boolean;
    closeOnEsc?: boolean;
    main?: Snippet;
    bottom?: Snippet;
  }

  let { title = "", open = $bindable(false), closeOnEsc = true, main, bottom }: Props = $props();

  let overlay = $state<HTMLElement>();
  let modal = $state<HTMLElement>();
  let dragHandle = $state<HTMLElement>();

  function close() {
    open = false;
  }

  function handleClick(e: MouseEvent) {
    if (e.target == overlay) {
      // clicked on overlay => dismiss
      e.stopPropagation();
      close();
    }
  }

  function handleKeyDown(e: KeyboardEvent) {
    // console.log("DialogBase: handleKeyDown:", e);
    if (closeOnEsc && e.key === "Escape") {
      close();
      // e.preventDefault();
      return;
    }

    if (modal && e.key === "Tab") {
      trapFocus(modal, e);
      e.preventDefault();
      return;
    }

    // needed to prevent arrow up / down etc. in FileList
    e.stopPropagation();
  }

  const previouslyFocused = document.activeElement as HTMLElement;
  if (previouslyFocused) {
    onDestroy(() => {
      previouslyFocused.focus();
    });
  }
</script>

{#if open}
  <div
    role="button"
    tabindex="0"
    class="fixed inset-0 z-40 bg-black/50 text-sm"
    bind:this={overlay}
    onclick={handleClick}
    onkeydown={handleKeyDown}
  >
    <div
      role="dialog"
      class="absolute w-fit min-w-90 max-w-[80vw] shadow-md bg-white flex flex-col"
      bind:this={modal}
      use:draggable={{ handle: dragHandle }}
      use:positionModal
    >
      <!-- title area -->
      <div class="flex items-center px-8 py-4 border-t-8 border-blue-300 cursor-grab" bind:this={dragHandle}>
        <div class="grow font-semibold text-lg">
          {title}
        </div>
        <button class="hover:bg-gray-200" onclick={close}>
          <Close size="24" />
        </button>
      </div>

      <div class="bg-white px-8">
        {@render main?.()}
      </div>

      <div class="bg-gray-50 px-8 py-4 mt-8">
        {@render bottom?.()}
      </div>
    </div>
  </div>
{/if}
